<template>
  <fragment v-if="entity && flow">
     <div class="row">
      <div id="contract-menu" class="col-lg-12 col-xl-3">
        <div class="card m-b-30">
          <div class="card-body">
            <div
              class="nav flex-column nav-pills"
              id="v-pills-product-tab"
              role="tablist"
              aria-orientation="vertical"
            >
              <a
                class="nav-link mb-2 active"
                id="v-pills-general-tab"
                data-toggle="pill"
                href="#v-pills-general"
                role="tab"
                aria-controls="v-pills-general"
                aria-selected="true"
              >
                <i class="feather icon-info mr-2"></i>Generale
              </a>
              <a
              v-if="$route.params.id"
                class="nav-link mb-2"
                id="v-pills-attachments-tab"
                data-toggle="pill"
                href="#v-pills-attachments"
                role="tab"
                aria-controls="v-pills-attachments"
                aria-selected="false"
              >
                <i class="feather icon-download mr-2"></i>Documenti <span class="badge badge-warning" id="documenti-da-validare"></span>
              </a>
              <a
              v-if="$route.params.id && !(isInRole('superuser')|| isInRole('customer'))"
                class="nav-link mb-2"
                id="v-pills-email-tab"
                data-toggle="pill"
                href="#v-pills-email"
                role="tab"
                aria-controls="v-pills-email"
                aria-selected="false"
              >
              <strong  v-if="entity.emailToProcess>0">
                <i class="feather icon-mail mr-2"></i>Emails
                <span class="badge badge-info ml-5">{{entity.emailToProcess}}</span>
              </strong>
               <span v-if="entity.emailToProcess==0">
                <i class="feather icon-mail mr-2"></i>Emails
                
              </span>
              </a>
                <a
              v-if="$route.params.id && !(isInRole('user') || isInRole('superuser')|| isInRole('customer')|| isInRole('readonly')) && related.length>0"
                class="nav-link mb-2"
                id="v-pills-related-tab"
                data-toggle="pill"
                href="#v-pills-related"
                role="tab"
                aria-controls="v-pills-related"
                aria-selected="false"
                @click="renderRelated"
              >
                <i class="feather icon-layers mr-2"></i>Contratti collegati <span class="badge badge-info ml-5">{{related.length}}</span>
              </a>
              <a
              v-if="$route.params.id  && !(isInRole('user') || isInRole('superuser') || isInRole('customer') || isInRole('readonly'))"
                class="nav-link mb-2"
                id="v-pills-note-tab"
                data-toggle="pill"
                href="#v-pills-note"
                role="tab"
                aria-controls="v-pills-note"
                aria-selected="false"
              >
                <i class="feather icon-edit-1 mr-2"></i>Note
              </a>
 
               <a
              v-if="$route.params.id && !(isInRole('user') || isInRole('superuser')|| isInRole('customer')|| isInRole('readonly'))"
                class="nav-link mb-2"
                id="v-pills-history-tab"
                data-toggle="pill"
                href="#v-pills-history"
                role="tab"
                aria-controls="v-pills-history"
                aria-selected="false"
                @click="history=null"
              >
             
             
                <i class="feather icon-clock mr-2"></i>Versioni
                
             
              </a>
            </div>
          </div>
        </div>

        <noteinfo v-if="$route.params.id  && !(isInRole('user') || isInRole('superuser') || isInRole('customer') || isInRole('readonly'))" :value="entity.contractId" v-bind:key="noteid" />
      </div>
      <div class="col-lg-12 col-xl-9" id="contract-tabs" >
        <div class="card mb-3"  v-if="flow.canContinue && !entity.new && flow.nextState != entity.state && !(isInRole('user') || isInRole('customer') ||isInRole('superuser')|| isInRole('readonly'))">
<div class="card-body">
<button
              @click="raiseNextState()"
              class="btn btn-success" 
            ><i class="feather icon-play mr-2"></i> Passa a {{ flow.nextState | contractState }}
            </button>

      
                    </div>
        </div>
        <div class="card m-b-30">
          <div class="card-body">
            <div class="tab-content" id="v-pills-product-tabContent">
              <div
                class="tab-pane fade show active"
                id="v-pills-general"
                role="tabpanel"
                aria-labelledby="v-pills-general-tab"
              >
                <!-- generale -->
                <div id="baseinformation" v-if="entity">
                  <company :outsourcers=outsourcers  :externalOperators=externalOperators :regexPattern="regexPattern" :procedures="procedures" :ransoms="ransoms" :subRansoms="subRansoms" :attachemntTypes="attachemntTypes" :entity="entity" :flow="flow" :operators="operators" @loadData="loadData" :checkedDocumentation="checkedDocumentation" :documentations="documentations" @ransomChange="ransomChange"/>
                </div>
              </div>

         <div
                class="tab-pane fade"
                id="v-pills-related"
                role="tabpanel"
                aria-labelledby="v-pills-related-tab"
              >
             <table ref="table" id="list-related-table" class="table table-hover w-100"></table>
              </div>
              <div
                class="tab-pane fade"
                id="v-pills-note"
                role="tabpanel"
                aria-labelledby="v-pills-note-tab"
              >
              <notelist :value="entity.contractId" :readOnly=" !readOnlyControl('document')" @update="noteid++"/>
              </div>

              <div
                class="tab-pane fade"
                id="v-pills-attachments"
                role="tabpanel"
                aria-labelledby="v-pills-attachments-tab"
              >
              <attachments :value="entity.contractId" :key="keypage" @update="loadData" :readOnly=" readOnlyControl('document') || isInRole('user') || isInRole('customer') ||isInRole('superuser')|| isInRole('readonly')"/>
              </div>
              <div
                class="tab-pane fade"
                id="v-pills-email"
                role="tabpanel"
                aria-labelledby="v-pills-email-tab"
              >
              <inboxemail :value="entity.contractId" selectable=true  @update="loadData" v-if="!entity.new" :key="keypage"></inboxemail>
              </div>

                <div
                class="tab-pane fade"
                id="v-pills-history"
                role="tabpanel"
                aria-labelledby="v-pills-history-tab"
              >
             
              <table class="table w-100" v-if="!history">
<thead></thead>
<tbody>
<tr v-for="(h,index) in histories" v-bind:key="index">
  <td>
    <span class="badge badge-primary mb-2">{{h.state | contractState}}</span>
    <span class="d-block">Modificata da <strong>{{h.user.firstName}} {{h.user.lastName}}</strong> {{h.insertDate | formatFullNameDate}}
    <button class="btn btn-sm btn-primary-rgba p-1" @click="viewHistory(h.historyContractId)">
      <i class="feather icon-eye"></i>
      Visualizza</button>
    </span>
  
  </td>
  </tr>

</tbody>

              </table>

             <company @close="history=null" name="h" v-if="history" :entity="history" :regexPattern="regexPattern" :procedures="procedures" :ransoms="ransoms" :subRansoms="subRansoms" :attachemntTypes="attachemntTypes"  :flow="flow" :operators="operators" @loadData="loadData" :checkedDocumentation="checkedDocumentation" :documentations="documentations"/>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  
  </fragment>
</template>

<script>
import Editor from "@tinymce/tinymce-vue";
import axios from "axios";
import { Chrome } from "vue-color";
import company  from "../contract/info";
import noteInfo from "../../components/Note/list.vue";
export default {
  data() {
    return {
      noteid:1,
      entity: null,
      flow: null,
      procedures: null,
      ransoms: null,
      subRansoms: [],
      regexPattern: null,
      externalOperators:[],
      operators: [],
      outsourcers: [],
      documentations: [],
      checkedDocumentation: [],
      companyDetail:false,
      related:[],
      attachemntTypes:[],
        options: [],
        histories:[],
        history:null,
        keypage:"aaaa"
    };
  },
  computed: {
    tinyKey: function () {
      return window.SETTINGS.TinyApiKey;
    },
    cuser() {
      return this.$store.state.user;
    },
  },
  components: {
    Editor,
    "chrome-picker": Chrome,
    company,
    "noteinfo":noteInfo
  },
  name: "ContractSave",
  beforeMount() {
    var me = this;
    axios.get("procedure/list").then((response) => {
      me.procedures = response.data;
      axios.get("ransom/list").then((response) => {
        me.ransoms = response.data;
        me.loadData(true);
      });
    });
  },
  methods: {
     edit: function (cid,id) {
      this.$router.push({ name: "route-contract-edit", params: { cid: cid, id: id } });
      this.$router.go();
      return false;
    },
    raiseNextState() {
      var me = this;
      me.$swal({
        title: "Sicuri di voler passare a ",
        html: "\"<strong>"+me.$options.filters.contractState(me.flow.nextState)+"\"</strong>",
        type: "question",
        showCancelButton: true,
        confirmButtonClass: "btn-danger-rgba",
        confirmButtonText: "Procedi",
        cancelButtonText: "Annulla",
      }).then(function (isconfirm) {
        if (isconfirm.value) {
          axios
            .post(
              `contract/${me.$route.params.cid}/${
                me.$route.params.id || ""
              }/raise`
            )
            .then((response) => {
              me.loadData();
            });
        }
      });
    },
    isInRole(role) {
      for (var i = 0; i < this.cuser.roles.length; i++) {
        if (this.cuser.roles[i] == role) {
          return true;
        }
      }
      return false;
    },
    renderRelated(){
       window["EditAction"] = this.edit;
      var me = this;
 if ($.fn.DataTable.isDataTable("#list-related-table")) {
        $("#list-related-table").DataTable().destroy();
      }

      var $table = $("#list-related-table").DataTable({
         "searching": false,
    "ordering": false,
        processing: false,
        serverSide: false,
      data: me.related,

        columns: [
          {
            data: "contractId",
            name: "contractId",
            title: "Ragione sociale",
            render: function (data, type, row, meta) {
            
              var retval=`
               <span class="badge badge-success capitalize ${row.procedureId}">${row.procedureId}</span> <span class="badge badge-info capitalize">${row.ransomId} ${row.subRansomId|| ''}</span>
             <span class="badge  float-right p-0 mr-2"><img class="img-fluid" style="height:25px"  src="assets/images/logo/${row.companyId}.svg"/></span>
            <span class="badge badge-info float-right p-2  mr-2">${me.$options.filters.contractState(row.state)}</span> 
           
            
             <h4>${row.code} </h4>
              <h5>${row.companyName}</h5>
            
             
              `;
              if(row.operator){
  retval+=`<p class="text-muted"><i class="feather icon-user mr-2"></i>${row.operator.firstName} ${row.operator.lastName}</p>`

              }
              if(row.emailToProcess>0){
               retval+=`<strong><i class="feather icon-mail mr-2"></i>${row.emailToProcess}
              <i class="feather icon-calendar ml-2 mr-2"></i>${me.$options.filters.formatDate(row.lastEmailToProcess)}</strong>`
              }

              if(row.missingDocumentation){
 retval+=`<strong class="ml-5 text-danger"><i class="fa fa-file-pdf-o mr-2"></i>DOCUMENTAZIONE CARENTE</strong>`

              }

            
                  return retval;
            },
          },
          {
            className: "text-right",
            data: "contractId",
            name: "contractId",
            title: "Azioni",
            render: function (data, type, row, meta) {
             
              
              return `<div class="button-list"><button type="button" class="btn btn-success-rgba" data-id="${data}" onClick="window.EditAction('${row.companyId}','${row.contractId}')"><i class="feather icon-edit-2"></i></button>
                                    <button type="button" class="btn btn-danger-rgba remove-action d-none"  data-id="${data}"><i class="feather icon-trash"></button></div>`;
            },
          },
        ],

         createdRow: function( row, data, dataIndex ) {
        // Set the data-status attribute, and add a class
     $(row).addClass('importance importance-'+data.importance);
    }
      });


    },

    loadData(bypass) {
   
      this.histories = [];
this.history  = null;
      var me = this;
      axios.get("contract/documentation").then((response) => {
        me.documentations = response.data;
      });

      axios.get("contract/" + me.$route.params.cid + "/externalOperators").then((response) => {
me.externalOperators = response.data;

      });
       axios.get("contract/outsourcer").then((response) => {
me.outsourcers = response.data;

      });
      if(me.$route.params.id)
      {
      axios
        .get(
          "contract/" + me.$route.params.cid + "/related/" + (me.$route.params.id || "")
        ).then((response)=>{
          me.related = response.data;
me.renderRelated();

        })
   }
      axios
        .get(
          "contract/" + me.$route.params.cid + "/" + (me.$route.params.id || "")
        )
        .then((response) => {
         //  
         
        me.entity = response.data;
        if(me.entity.taxation =='' || me.entity.taxation == null)
        me.entity.taxation = 'none';
         let r = Math.random().toString(36).substring(7);
          me.keypage =r;
          me.entity.new = me.$route.params.id?false:true;
          me.regexPattern = `^${me.entity.company.contractRegex}$`;
          if(me.entity.parentContractId){

             me.regexPattern = `^.+$`;
          }

          if (me.entity.code != "")
            me.$store.state.breadCrump.title = me.entity.code;
          if (!me.entity.procedureId)
            me.entity.procedureId = me.procedures[0].procedureId;

          if (!me.entity.ransomId) {
            me.entity.ransomId = me.ransoms[0].ransomId;
            me.ransomChange();
          }

          me.loadSubRansoms();

    axios.get(`contract/histories/${me.entity.contractId}`).then((response)=>{
me.histories = response.data;

          });


          axios.get(`contract/attachmentTypes/${me.entity.contractId}`).then((ratt)=>{
          
me.attachemntTypes = ratt.data;

          });
          if (me.entity.documentation)
            me.checkedDocumentation = me.entity.documentation.split(",");
          axios
            .get(
              "contract/flow/" +
                me.$route.params.cid +
                "/" +
                (me.$route.params.id || "")
            )
            .then((response) => {
         
              me.flow = response.data;
                if(bypass && me.entity.new || (!me.entity.new && (me.isInRole("user")|| me.isInRole("superuser")))) {
                me.flow.error=false;
                me.flow.errors=[];
                }
              if (me.actionEnable("ChoiceCommercialOperator")) {
                axios
                  .get("contract/operators/commercialoperator")
                  .then((response) => {
                    me.operators = response.data;
                  });
              }
              if (me.actionEnable("ChoiceOperator")) {
                axios.get("contract/operators/operator|superoperator").then((response) => {
                  me.operators = response.data;
                });
              }
            });

             
        });
    },
    readOnlyControl(code) {
      if (this.flow) {
        return (
          this.flow.readOnlyControl.indexOf("*") >= 0 ||
          this.flow.readOnlyControl.indexOf(code) >= 0
        );
      }
      return false;
    },
    viewHistory(id){
  axios
                  .get("contract/history/"+id)
                  .then((response) => {
                    this.history = response.data;
                  });

    },
    ransomChange() {
      this.subRansoms = [];
      this.entity.subRansomId = null;
      for (var i = 0; i < this.ransoms.length; i++) {
        var r = this.ransoms[i];
        if (r.ransomId == this.entity.ransomId) {
          this.subRansoms = r.subRansoms;
          if (this.subRansoms.length > 0 ) {
            this.entity.subRansomId = this.subRansoms[0].subRansomId;
          }
          break;
        }
      }
    },
    loadSubRansoms() {
      this.subRansoms = [];
     
      for (var i = 0; i < this.ransoms.length; i++) {
        var r = this.ransoms[i];
        if (r.ransomId == this.entity.ransomId) {
          this.subRansoms = r.subRansoms;
         
          break;
        }
      }
    },
    actionEnable(action) {
      for (let index = 0; index < this.flow.actions.length; index++) {
        var a = this.flow.actions[index];

        if (action.toLowerCase() == a.toLowerCase()) return true;
      }
      return false;
    },
    hideControl(code) {
      if (this.flow) {
        return (
          this.flow.hideControl.indexOf("*") >= 0 ||
          this.flow.hideControl.indexOf(code) >= 0
        );
      }
      return true;
    },
    showTabs(tab) {
      $(".tabs .card").addClass("d-none");
      $("#" + tab).removeClass("d-none");
    },
    cancel() {
      this.$router.push({
        name: "route-contract-list",

        replace: true,
      });
    },
    
    save() {
      let me = this;
      me.entity.documentation = me.checkedDocumentation.join(",");
      axios
        .post(
          `contract/${me.$route.params.cid}/${me.$route.params.id || ""}`,
          this.entity
        )
        .then((response) => {
        
          if (response.data.error && response.data.code == 200) {
            me.$swal({
              title:
                "Salvataggio avvenuto correttamente, ma controlla i dati inseriti",
              text: "",
              type: "warning",
              showCancelButton: false,
              toast: true,
              timer: 2000,
              showConfirmButton: false,
              position: "bottom-top",
            });
          } else if (response.data.error && response.data.code != 200) {
            me.$swal({
              title: "Impossibile proseguire",
              text: "",
              type: "danger",
              showCancelButton: false,
              toast: true,
              timer: 2000,
              showConfirmButton: false,
              position: "bottom-top",
            });
            me.flow.error = response.data.error;
            me.flow.errors = response.data.errormessages;
            return;
          } else if (!response.data.error) {
            me.$swal({
              title: "Salvataggio avvenuto correttamente",
              text: "",
              type: "success",
              showCancelButton: false,
              toast: true,
              timer: 2000,
              showConfirmButton: false,
              position: "bottom-top",
            });
          }

            if(!me.$route.params.id)
          {
me.$router.push({ name: "route-contract-edit", params: { cid: me.entity.companyId, id: me.entity.contractId } });
             
          }else{
          me.loadData();
          }
        });
    },
     onSearch(search, loading) {

               
                //  ... do some asynchronous stuff!
                loading(true);
                this.search(loading, search, this);
                //return [{"cap":"43100", "comune":"parma"}];
            },
            search: _.debounce((loading, search, vm) => {
                axios.get(
                    `cap?q=${escape(search)}`
                ).then(res => {
                    vm.options = res.data;
                    loading(false);
                });
            }, 350)
            ,
  },
};
</script>
